import type { UIMessage } from 'ai';
import { useCallback, useState } from 'react';

const extractTextContent = (message: UIMessage): string =>
  (message.parts ?? [])
    .filter((p): p is { type: 'text'; text: string } => p.type === 'text')
    .map((p) => p.text)
    .join('');

export function useMessageParser() {
  const [parsedMessages, setParsedMessages] = useState<{ [key: number]: string }>({});

  const parseMessages = useCallback((messages: UIMessage[], _isLoading: boolean) => {
    const next: { [key: number]: string } = {};

    for (const [index, message] of messages.entries()) {
      if (message.role === 'assistant' || message.role === 'user') {
        next[index] = extractTextContent(message);
      }
    }

    setParsedMessages(next);
  }, []);

  return { parsedMessages, parseMessages };
}
